import { useQuery } from "@tanstack/react-query";
import { rankingApi } from "@bw/shared/api";
import type { PlayerRatingResponse } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * Another player's PUBLIC rating (GET /ranking/rating/{userId}). Disabled until
 * a userId resolves (e.g. an unresolved route param), so it never fires a
 * request for `undefined`.
 */
export function useRating(userId: string | undefined) {
  return useQuery<PlayerRatingResponse>({
    queryKey: queryKeys.compete.rating(userId ?? ""),
    queryFn: () => rankingApi.getRating(userId as string),
    enabled: Boolean(userId),
  });
}
